/* unplugin-vue-components disabled */import script from "./LatelyManage.vue?vue&type=script&setup=true&lang=js"
export * from "./LatelyManage.vue?vue&type=script&setup=true&lang=js"

import "./LatelyManage.vue?vue&type=style&index=0&id=64643e4d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64643e4d"]])

export default __exports__